var React = require('react');
var ReactNative = require('react-native');

var Icon = require('./wrappers/ReUpIcon');

var ReUpScrollView = require('./ReUpScrollView.js');
var ShadowView = require('./ShadowView.js');
var PriceChooserView = require('./PriceChooserView.js');

var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager.js');
var ModelConstants = require('./constants/ModelConstants.js');

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKColor,
  MKCardStyles,
  MKTextField,
  MKButton
} = MK;

var MKSegmentControl = require('./MKSegmentControl.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ReUpField = require('./ReUpField.js');
var ReUpText = require('./ReUpText');

var {
  AppRegistry,
  Text,
  View,
  Image,
  StyleSheet,
} = ReactNative;

var SendCredit = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      initialLayout : {},
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      message : "",
      numMessageLines : 1,
      sendButton:"Send",//TODO:localize
      emailError:false,
      nameError:false,
    }
  },

  componentDidMount : function()
  {
  },

  componentWillUnmount : function()
  {
  },

  _email : "",
  _emailHasBeenValid : false,
  emailChanged : function(email)
  {
    this._email = email;
    var emailValid = this.props.appManager.isValidEmail(email);
    if( this._emailHasBeenValid && !emailValid && !this.state.emailError )
    {
      this.setState({emailError:true})
    }

    if( emailValid )
    {
      this._emailHasBeenValid = true;
      if( this.state.emailError )
      {
        this.setState({emailError:false});
      }
    }
  },

  _name : "",
  _nameHasSucceeded : false,
  nameChanged : function(text)
  {
    this._name = text;
    var nameError = !(text.indexOf(" ") > -1);
    if( nameError != this.state.nameError && this._nameHasSucceeded )
    {
      this.setState({nameError:nameError});
    }

    if( !nameError ) this._nameHasSucceeded = true;
  },

  _message : "",
  messageChanged : function(message)
  {
    this._message = message;
    this.setState({message:message});
  },

  submitPressed : function()
  {
    var appActions = this.props.appActions;
    var thisThing = this;
    var locManager = this.props.appManager.getLocalizationManager();
    var user = this.props.appManager.currentUser();
    if( !this.props.appManager.isValidEmail(this._email) || user[ModelConstants.UserName].toLowerCase() == this._email.toLowerCase() )
    {
      this.setState({emailError:true});
      appActions.showLocalizedAlert("CREATEUSER_EMAIL_INVALID_FAIL_ALERT_TITLE", "CREATEUSER_EMAIL_INVALID_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
      {
        appActions.hideAlert();
        thisThing._ref_email.focus();
      }], function(){})
    }
    else if( this._name.indexOf(" ") < 0 ) // name error
    {
      this.setState({nameError:true})
      var theirFirstLastNameError = "Please enter their first and last name.";
      appActions.showLocalizedAlert("NAME_EMPTY_FAIL_ALERT_TITLE", theirFirstLastNameError, ["OK_ALERT_BUTTON"], [function()
      {
        appActions.hideAlert();
        thisThing._ref_name.focus();
      }], function(){})
    }
    else
    {
      var email = this._email;
      var message = this._message;
      var amount = this._ref_PriceChooserView.getAmount();
      var thisThing = this;
      var user = this.props.appManager.getCurrentUser(function(user)
      {
        var credit = user[ModelConstants.Credits];
        if( credit < amount )
        {
          appActions.showLocalizedAlert(locManager.localizedStringForKey("NSF_ALERT_TITLE"), locManager.localizedStringForKey("NSF_ALERT_BODY"), ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [function()
          {
            appActions.hideAlert();
            thisThing._ref_PriceChooserView.focus();
          }, function()
          {
            appActions.hideAlert();
            appActions.requestFeatureName("AddCredit");
          }], function(){})
        }
        else
        {
          var confirmTitle = locManager.localizedStringForKey("CONFIRM_ALERT_TITLE", "Confirmation");
          var confirmBody = locManager.localizedStringForKeyAndParams("SEND_CREDIT_CONFIRMATION_BODY", [locManager.localizedDollars(amount),thisThing._name, email],  "Would you like to send %0% to %1% (%2%)?");
          var yesButton = locManager.localizedStringForKey("YES_ALERT_BUTTON");
          var noButton = locManager.localizedStringForKey("NO_ALERT_BUTTON");
          appActions.setSpinnerShown(false);
          appActions.showAlert(confirmTitle,confirmBody,[noButton, yesButton], [function(){appActions.hideAlert()},function(){appActions.hideAlert(); thisThing.send(amount, email, message)}]);
        }
      })
    }
  },

  send : function(amount, email, message)
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = appManager.getLocalizationManager();
    var processingHUD = locManager.localizedStringForKey("PAYING_HUD");

    var names = this._name.split(" ");
    var lastName = names[names.length-1];
    var firstName = "";
    for( var i = 0; i < names.length-1; i++ )
    {
      if( firstName.length > 0 ) firstName += " ";
      firstName += names[i];
    }

    appActions.setSpinnerShown(true, processingHUD);
    NetworkManager.sendCredit( appManager, amount, email, message, firstName, lastName, function(data)
    {
      appActions.setSpinnerShown(false);
      var user = appManager.currentUser();
      user[ModelConstants.Credits] = parseFloat(user[ModelConstants.Credits]) - amount;
      var sendSuccess = locManager.localizedStringForKey("SEND_CREDIT_SUCCESS_ALERT_TITLE");
      var creditSent = locManager.localizedStringForKey("SEND_CREDIT_SUCCESS_ALERT_BODY");
      var okayText = locManager.localizedStringForKey("OK_ALERT_BUTTON");
      appManager.setCurrentUser(user, function()
      {
        appActions.showAlert(sendSuccess,creditSent,[okayText],[function(){appActions.requestPop(false);appActions.hideAlert();}]);
      });
    },
    function(data)
    {
      var sendFailedTitle = locManager.localizedStringForKey("SEND_CREDIT_FAIL_ALERT_TITLE");
      var sendFailedBody = locManager.localizedStringForKey("SEND_CREDIT_FAIL_ALERT_BODY");
      var okayText = locManager.localizedStringForKey("OK_ALERT_BUTTON");
      appActions.setSpinnerShown(false);
      appActions.showAlert(sendFailedTitle,sendFailedBody,[okayText]);
    }, function(data)
    {
      appActions.setSpinnerShown(false);
      appActions.showNetworkErrorAlert(appActions.hideAlert, function(){})
    })
  },

  didUpdate : function(data)
  {

  },

  didStartChoosingPrice: function()
  {
    this._ref_ptr.setRefreshEnabled(false);
  },

  didEndChoosingPrice: function()
  {
    this._ref_ptr.setRefreshEnabled(true);
  },

  render: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();
    var user = this.state.user;

    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");

    var creditsLeftStatement = locManager.localizedStringForKey("CREDITS_LEFT_STATEMENT");
    var howMuchCreditToSendStatement = locManager.localizedStringForKey("SEND_GC_AMOUNT_LABEL");
    var whoToSendStatement = locManager.localizedStringForKey("SEND_GC_RECIPIENT_LABEL");
    var emailLabel = locManager.localizedStringForKey("EMAIL_LABEL");
    var messageLabel = locManager.localizedStringForKey("SEND_GC_MESSAGE_LABEL");
    var sendButton = locManager.localizedStringForKey("SEND_BUTTON");
    var priceChooserProps = {};
    if( typeof this.props.featureData.choiceValue !== 'undefined' )
    {
      priceChooserProps.choiceValue = this.props.featureData.choiceValue;
    }
    if( typeof this.props.featureData.choiceIndex !== 'undefined' )
    {
      priceChooserProps.initialIndex = this.props.featureData.choiceIndex;
    }

    var nameLabel = "Name (First and Last):";//locManager.localizedStringForKey("NAME_LABEL");

    return (
      <View style={styles.container}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
        <View style={[styles.backgroundView, {width:this.state.layout.width, height:this.state.layout.height, backgroundColor: generalColor}]} />

        <ReUpScrollView ref={(c) => { this._ref_ptr = c; }} bounces={true} responder={this}>
          <View style={[styles.instructionContainer, {backgroundColor: instructionColor}]}>
            <View style={{alignSelf:'center'}}>
              <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={[styles.instructionText, {color:instructionTitleColor}]}>
                {creditsLeftStatement}
              </ReUpText>
            </View>
            <View style={{flex:1}} />
            <ReUpIconButton type={3}
              appManager={appManager}
              featureData={this.props.featureData}
              appActions={appActions}
              />
          </View>
          <ShadowView layout={this.state.layout} appManager={appManager}/>
          <View>
            <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={[styles.bodyText, {color:generalTitleColor}]}>
              {howMuchCreditToSendStatement}
            </ReUpText>
            <PriceChooserView ref={(c) => { this._ref_PriceChooserView = c; }} style={[styles.choicesContainer,{marginBottom:10}]} appManager={this.props.appManager}
              initialLayout={this.state.layout} didChangeValueAndText={(v,t)=>thisThing.setState({sendButtonTitle:sendButton+" - "+t})}
              didStartChoosingPrice={this.didStartChoosingPrice} didEndChoosingPrice={this.didEndChoosingPrice}
              {...priceChooserProps} />
              <ShadowView layout={this.state.layout} appManager={appManager}/>
            <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={[styles.bodyText, {color:generalTitleColor}]}>
              {whoToSendStatement}
            </ReUpText>
            <ReUpField
              appManager={appManager}
              key="email" ref={(c) => { this._ref_email = c; }}
              autoCapitalize={'none'}
              keyboardType={'email-address'}
              onChangeText={this.emailChanged}
              placeholder={emailLabel}
              isInError={this.state.emailError}
              style={[styles.textField,{margin:10, marginTop:0}]}/>
            <ReUpField
              appManager={appManager}
              key="name" ref={(c) => { this._ref_name = c; }}
              autoCapitalize={'words'}
              onChangeText={this.nameChanged}
              placeholder={nameLabel}
              isInError={this.state.nameError}
              style={[styles.textField,{margin:10, marginTop:0}]}/>
            <ReUpField
              appManager={appManager}
              key="message" ref={(c) => { this._ref_message = c; }}
              onChangeText={this.messageChanged}
              placeholder={messageLabel}
              isInError={false}
              style={[{margin:10, marginTop:0, borderWidth:0,borderColor:generalTitleColor, borderBottomWidth:0,
                flex:1,
                width:-1,
                height:22+Math.max(1,this.state.numMessageLines)*30,
                marginTop:0}]}
              numberOfLines={3}
              multiline={true}/>
            <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={[{position:'absolute',margin:10, borderWidth:0,borderColor:generalTitleColor, borderBottomWidth:0,
              flex:1,
              width:-1,
              marginTop:10,fontFamily: 'Arial', padding:2, opacity:0}]} onLayout={(evt)=>{var numMessageLines = parseInt(evt.nativeEvent.layout.height)/29; thisThing.setState({numMessageLines:numMessageLines})}} >
              {this.state.message}
            </ReUpText>
            <ReUpButton appManager={appManager} style={[styles.doneButton]} text={this.state.sendButtonTitle}
              onPress={this.submitPressed} />
          </View>
        </ReUpScrollView>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  instructionContainer: {
    flexDirection:'row',
  },
  instructionText: {
    margin:10,
  },
  backgroundView: {
    position: 'absolute',
  },


  // meter

  meterContainer: {
    margin:10,
    height:20,
    borderRadius:10,
    flexDirection:'row',
  },
  meterFiller: {
    margin:1,
    height:18,
    borderRadius:9,
  },
  meterAntiFiller: {
    height:18,
    borderRadius:9,
  },

  // body

  bodyText: {
    margin:10,
    textAlign:'left',
  },

  alertTitle: {
    margin:4,
    textAlign:'center',
  },

  // choices

  choicesContainer: {
    flexDirection:'row',
    marginTop:0,
    marginBottom:0,
    marginLeft:0,
    marginRight:0,
    height:50,
    alignItems:'center',
    justifyContent:'center'
  },
  choiceButton: {
    justifyContent:'center',
    flex:1,
    height:40,
  },

  // credit card
  oldCardContainer: {
    flexDirection:'row',
    margin:10,
    alignItems:'center',
    marginLeft:20,
    marginRight:20,
    justifyContent:'center',
  },
  creditCardIcon: {
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    fontSize:26,
    padding:4,
    opacity:.6,
  },
  creditCardText: {
    fontStyle:'italic',
    padding:4,
    flex:1,
    textAlign:'center',
    opacity:.6,
  },
  creditCardEditButton: {
    padding:4,
  },
  creditCardEditButtonIcon: {
    fontSize:30,
    backgroundColor:'transparent'
  },

  // new card
  cardNumberContainer: {
    flexDirection: 'row',
    margin:8,
    marginTop:0
  },

  textField: {
    flex:1,
    width:-1,
    height:50,
    marginTop:10
  },

  dateContainer: {
    flexDirection: 'row',
    alignItems:'flex-end',
    margin:8,
    marginTop:0,
  },
  dateField: {
    flex:-1,
    width:40,
    textAlign:'center',
  },
  cvvField: {
    flex:-1,
    width:80,
    textAlign:'center',
  },
  dateSlash: {
    paddingLeft:8,
    paddingRight:8,
    alignSelf:'flex-end',
    textAlign:'center',
  },

  doneButton: {
    justifyContent:'center',
    flex:1,
    marginRight:10, marginLeft:10, marginBottom:10,
  },

  segmentContainer: {
    height:50,
    padding:4,
    flex:1,
    alignSelf:'center'
  }
});

SendCredit.getCards = function(featureData, appActions, data)
{
  var appManager = appActions._appManager;
  var isLoggedIn = appManager.isLoggedIn();

  if( !isLoggedIn || typeof ModelConstants === 'undefined' ) return [];
  else
  {
    var user = appManager.currentUser();
    var credit = user[ModelConstants.Credits]
    if( credit < 20) return [];

    var didSelect = function() {appActions.requestFeatureName("SendCredit")};
    var iconName = featureData.data.icon.replace("fa-", "")
    return [{
      didSelect : didSelect,
      title : featureData.data.title,
      body1 : featureData.data.tip,
      icon : iconName,
      cardType : 0,
      sortOrder : 0
    }];
  }
}



SendCredit.dataDependencies = ["Users"];

module.exports = SendCredit;
